var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectTypeHedgerowAndAgroforestry({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.5V15.5L10 13.5",
    stroke: "#78BB96",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14.5L12 16.5M17 8.5V9.3C18.1625 9.96723 19.0682 11.0045 19.5725 12.2464C20.0767 13.4883 20.1507 14.8633 19.7824 16.1521C19.4142 17.4409 18.625 18.5693 17.5408 19.3574C16.4565 20.1454 15.1396 20.5476 13.8 20.5H10C8.62897 20.4069 7.32269 19.8817 6.26881 18.9998C5.21493 18.1178 4.46768 16.9246 4.13438 15.5914C3.80109 14.2582 3.8989 12.8537 4.41377 11.5796C4.92864 10.3055 5.83407 9.22734 7.00002 8.5C7.00002 7.17392 7.52681 5.90215 8.46449 4.96447C9.40217 4.02678 10.6739 3.5 12 3.5C13.3261 3.5 14.5979 4.02678 15.5356 4.96447C16.4732 5.90215 17 7.17392 17 8.5Z",
    stroke: "#78BB96",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectTypeHedgerowAndAgroforestry);
export default __webpack_public_path__ + "static/media/project-type-hedgerow-and-agroforestry.8c404f178929dc19538db1d31849673c.svg";
export { ForwardRef as ReactComponent };